import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import conference from "../../../assets/utils/images/top-img.png";
import live_call from "../../../assets/utils/images/live-calls.png";
import video_api from "../../../assets/utils/images/video-api.png";
import video_kiosk from "../../../assets/utils/images/video-kiosk.png";

import { withRouter } from "react-router";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import {
  auth,
  signInWithGoogle,
  recaptchaVerifier,
} from "../../../Auth/Firebase";
import { isAuthenticated } from "../../../States/Token";
import { config } from "../../../config";
import { get_landing_page } from "../../../Helpers/Router";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile_number: "",
      otp_requested: false,
      otp: "",
      message: "",
      otp_timeout: 0,
      disable_input: false
    };
    this.recaptchaVerifier = null;
    this.confirmationResult = null;

    this.requestOTPHandler = this.requestOTPHandler.bind(this);
    this.loginWithOTPHandler = this.loginWithOTPHandler.bind(this);
    this.startOTPCountdown = this.startOTPCountdown.bind(this);
  }

  componentDidMount() {
    if (isAuthenticated()) {
      this.props.history.push(get_landing_page());
    }
    this.recaptchaVerifier = new recaptchaVerifier("login_to_dashboard", {
      size: "invisible",
      callback: (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // console.log("SUCCESSFULL SIGNIN");
      },
    });
  }

  startOTPCountdown = () => {
    setTimeout(() => {
      if (this.state.otp_timeout > 0) {
        this.state.otp_timeout -= 1;
        this.setState({ otp_timeout: this.state.otp_timeout });
        this.startOTPCountdown();
      }
    }, 1000);
  };

  requestOTPHandler = (mobile_number) => {
    this.setState({message: ""});
    if (!mobile_number.trim()) {
      this.setState({ message: "Mobile number cannot be empty." });
      return;
    }
    this.setState({disable_input: true});
    auth
      .signInWithPhoneNumber(mobile_number, this.recaptchaVerifier)
      .then((confirmationResult) => {
        this.confirmationResult = confirmationResult;
        this.state.otp_timeout = 30;
        this.setState({
          otp_requested: true,
          otp_timeout: this.state.otp_timeout,
        });
        this.startOTPCountdown();
        this.setState({disable_input: false});
      })
      .catch((error) => {
        this.setState({ otp_requested: false });
        this.setState({ message: error.message });
        this.setState({disable_input: false});
      });
  };

  loginWithOTPHandler = (otp) => {
    if (!otp.trim()) {
      this.setState({ message: "OTP cannot be empty" });
      return;
    }

    this.setState({disable_input: true});

    this.confirmationResult
      .confirm(otp)
      .then((result) => {
        // User signed in successfully.
        const user = result.user;
        this.props.history.push(get_landing_page());
        this.setState({disable_input: false});
        // ...
      })
      .catch((error) => {
        // User couldn't sign in (bad verification code?)
        // ...
        this.setState({ message: error.message });
        this.setState({disable_input: false});
      });
  };

  handleEnterPress = (event, callback) => {
    if(event.key === 'Enter'){
      callback();
    }
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    return (
      <Fragment>
        <div className="login-main">
        <div className="login-video">
  <video
    autoPlay
    loop
    muted
    className="sample-video h-100 no-gutters"
  >
    <source
      src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/hb-opt.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
</div>
       
        <div className="login-form">
          <Row className="h-100 no-gutters">
            <Col
              
              className="h-100 d-flex bg-white justify-content-center align-items-center"
            >
              <Col className="mx-auto app-login-box" style={{textAlign: "center"}}>
                {/* <div className="app-block-logo" /> */}
                <div> <img
                src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/sa-new-Logo.png"
                alt="SaleAssist Logo"
                style={{ width: "200px",marginRight:"25px"}} // Set size and margin for logo
              />
              </div>
              <div style={{ color: "grey",
                      backgroundColor: "white",
                      border: "none",
                      borderRadius: "0.25rem",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",  // Adds a subtle shadow for the card effect
                      padding: "10px 15px",  // Adds some padding to make it feel more like a card
                      backgroundSize: "70%",}}>
              <h6 className="mt-3">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.history.push("/auth/login");
                    }}
                  
                    style={{
                      color: "grey",
                      backgroundColor: "white",
                      height: "40px",
                      border: "none",
                      borderRadius: "0.25rem",
                      boxShadow: "0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25)",  // Adds a subtle shadow for the card effect
                      padding: "8px 12px",  // Adds some padding to make it feel more like a card
                      backgroundSize: "contain",
                      textDecoration:"none",
                      display:"inline-block",
                      marginBottom:"10px"
                    }}>
                      <i className="fas fa-envelope" style={{ marginRight: "8px" }}></i>
                    Sign in with email
                  </a>{" "}
                
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      signInWithGoogle();
                    }}
                    className="google-login-button"
                  ></Button>
                </h6>
                <Row className="divider" />
                <h6 className="mt-3 text-danger">{this.state.message}</h6>
                <div style={{textAlign:"center"}}>
                  <Form onSubmit={(e) => e.preventDefault()}>
                    <Row >
                      {!this.state.otp_requested && (
                        <Col md={12}>
                          <FormGroup>
                            <Label for="exampleEmail">Mobile number</Label>
                            <PhoneInput
                              placeholder="Enter mobile number"
                              country="IN"
                              onChange={(mobile_number) => {
                                this.setState({ mobile_number: mobile_number });
                              }}
                              onKeyPress={(e) => this.handleEnterPress(e, () => {this.requestOTPHandler(this.state.mobile_number)})}
                              value={this.state.mobile_number}
                              disabled={this.state.disable_input}
                            />
                            {/* <Input type="email" name="mobile_number" id="exampleEmail" placeholder="Enter your mobile number here..." onChange={(e) => {this.setState({mobile_number: e.target.value})}} value={this.state.mobile_number}/> */}
                          </FormGroup>
                        </Col>
                      )}
                      {this.state.otp_requested && (
                        <Col md={12}>
                          <FormGroup>
                            <Label for="examplePassword">OTP</Label>
                            <Input
                              type="text"
                              name="otp"
                              id="examplePassword"
                              placeholder="OTP here..."
                              onChange={(e) => {
                                this.setState({ otp: e.target.value });
                              }}
                              onKeyPress={(e) => this.handleEnterPress(e, () => {this.loginWithOTPHandler(this.state.otp)})}
                              value={this.state.otp}
                              disabled={this.state.disable_input}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                    {/* {this.state.otp_requested && (
                      <FormGroup check>
                        <Input type="checkbox" name="check" id="exampleCheck" />
                        <Label for="exampleCheck" check>
                          Keep me logged in
                        </Label>
                      </FormGroup>
                    )} */}
                    <Row className="divider" />
                    <div className="d-flex align-items-center">
                      <div className="ml-auto">
                        {this.state.otp_requested &&
                          this.state.otp_timeout === 0 && (
                            <>
                              <a
                                href="#"
                                className="btn-lg btn btn-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.requestOTPHandler(
                                    this.state.mobile_number
                                  );
                                }}
                              >
                                Resend OTP
                              </a>{" "}
                            </>
                          )}
                        {!this.state.otp_requested && (
                          <Button
                            id="login_to_dashboard"
                            className="login-btn"
                            size="lg"
                            onClick={(e) => {
                              e.preventDefault();
                              this.requestOTPHandler(
                                this.state.mobile_number
                              );
                            }}
                            disabled={this.state.disable_input}
                          >
                            Request OTP
                          </Button>
                        )}
                        {this.state.otp_requested && (
                          <Button
                            id="login_to_dashboard"
                            className="login-btn"
                            size="lg"
                            onClick={(e) => {
                              e.preventDefault();
                              this.loginWithOTPHandler(this.state.otp);
                            }}
                            disabled={this.state.disable_input}
                          >
                            Login to Dashboard
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
                
              </Col>
            </Col>
          </Row>
        </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(Login);
